import { useAction } from '@sde/widgets-core/src/redux/hooks/useAction';
import { useSelect } from '@sde/widgets-core/src/redux/hooks/useSelect';
import { setPayer } from './actions';

const payerSelector = (state) => state.payer;

export const usePayer = {
  state: () => {
    const payer = useSelect(payerSelector);
    return { payer };
  },
  actions: () => {
    return {
      setPayer: useAction(setPayer),
    };
  },
};
